/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, visuallyHiddenCss, colors } from '@chegg-ui/theme';
import styled from 'styled-components';
export var FieldSet = styled.fieldset.withConfig({
  componentId: "sc-19wsqt8-0"
})(["font-family:", ";margin:0;padding:0;border:0;overflow:visible;& > *{margin:0.25rem 0;}"], font.family["default"]);
export var VisuallyHiddenLegend = styled.legend.withConfig({
  componentId: "sc-19wsqt8-1"
})(["", ""], visuallyHiddenCss);
export var SelectionMenuContainer = styled.div.withConfig({
  componentId: "sc-19wsqt8-2"
})(["> div + div{margin-left:", ";margin-top:", ";}display:inline-flex;flex-direction:", ";"], function (_ref) {
  var menuDirection = _ref.menuDirection;
  return menuDirection === 'horizontal' ? '-2px' : 0;
}, function (_ref2) {
  var menuDirection = _ref2.menuDirection;
  return menuDirection === 'horizontal' ? 0 : '-2px';
}, function (_ref3) {
  var menuDirection = _ref3.menuDirection;
  return menuDirection === 'horizontal' ? 'row' : 'column';
});
export var SelectionMenuItem = styled.div.withConfig({
  componentId: "sc-19wsqt8-3"
})(["position:relative;display:flex;align-items:center;height:3rem;color:", ";padding:0 ", "rem;font-family:", ";font-weight:", ";cursor:pointer;&:after{content:'';position:absolute;top:0;left:0;height:100%;width:100%;border:2px solid ", ";z-index:", ";box-sizing:border-box;}&:hover:after{border-color:", ";z-index:3;}> svg{margin-right:", "rem;}"], colors.dark, 20 / 16, font.family.aspira, font.weight.medium, function (_ref4) {
  var isChecked = _ref4['aria-checked'];
  return isChecked ? colors.cheggOrange : colors.greyLight;
}, function (_ref5) {
  var isChecked = _ref5['aria-checked'];
  return isChecked ? 2 : 1;
}, function (_ref6) {
  var isChecked = _ref6['aria-checked'];
  return isChecked ? colors.cheggOrange : colors.greyMedium;
}, 10 / 16);